module.exports = __webpack_public_path__ + "mysource_files/loader.gif";